module.exports = __webpack_public_path__ + "img/32.c7885293.jpg";